import consumer from "./consumer"

consumer.subscriptions.create("FileImportProgressBarChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    const divText = $("#"+data.env+"_progress_bar_"+data.process+"_"+data.file_import_id+"_text")
    const divStatus = $("#"+data.env+"_progress_bar_"+data.process+"_"+data.file_import_id+"_status")
    const percentage = data.percentage;
    console.log("env: "+data.env+", process: "+data.process+", file_import_id: "+data.file_import_id+", porcentaje: "+percentage)
    divStatus.width(percentage+"%")
    divText.text(percentage+"%")
    window.localStorage.setItem(data.env+"_progress_bar_"+data.process+"_"+data.file_import_id, percentage)
  }
});
